var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 fill-height"},[_c('v-row',[_c('order',{attrs:{"order":_vm.order_view}})],1),_c('v-row',[_c('latest-orders')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }